import { render } from "./DateFrequencies.vue?vue&type=template&id=19370180&scoped=true"
import script from "./DateFrequencies.vue?vue&type=script&lang=ts"
export * from "./DateFrequencies.vue?vue&type=script&lang=ts"

import "./DateFrequencies.vue?vue&type=style&index=0&id=19370180&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19370180"

export default script